<template>
  <div class="bg-gray-200 pt-4 pb-32 min-h-screen">
    <div class="fixed inset-0 flex px-6" style="background: rgba(0,0,0,.3); z-index: 9;" v-if="shouldShowFinishedDialog">
      <div class="m-auto bg-white py-8 px-12 rounded-lg">
        <h3 class="text-lg font-bold">Se acabó el período de tu PillPack</h3>
        <p class="text-sm mt-2">Tu Pillpack asignado ha terminado su periodo de duración o no tienes asignado ningún PillPack.</p>
        <button class="bg-azuloscuro text-white rounded-full px-4 py-2 mt-6" @click="dismissFinishedDialog">Aceptar</button>
      </div>
    </div>
    <loading :active.sync="loading"></loading>
    <h1
      v-if="pendingPills.length == 1"
      class="text-azuloscuro text-xl font-semibold p-4 mb-2"
    >1 Pill pendiente</h1>
    <h1
      v-if="pendingPills.length !== 1"
      class="text-azuloscuro text-xl font-semibold p-4 mb-2"
    >{{pendingPills.length}} Pills pendientes</h1>

    <div class="mb-4 pb-4 px-6 overflow-auto">
      <div class="flex">
        <div v-for="(i, idx) in pendingPills" :key="idx">
          <div
            @click="abrirPill(i.pill.contentType, i, idx)"
            v-if="idx == 0"
            :class="{'bg-redpill' : i.pill.contentType === '0', 'bg-pdfpill': i.pill.contentType === '1', 'bg-orangepill': i.pill.contentType === '2', 'bg-verdeclaro': i.pill.contentType === '3', 'bg-verde': i.pill.contentType === '4' }"
            class="bg-pill-burbujas float-left rounded-lg px-6 py-6 border border-gray-300 shadow text-center mr-5 relative"
            style="width: 240px; min-height: 210px"
          >
            <div class="text-left">
              <img :src="require(`@/assets/images/atomos/${i.pill.contentType}.svg`)" class="w-12 h-12"/>
            </div>

            <hr class="mt-3 mb-3 text-white-50" />
            <div class="text-sm text-left text-white font-medium">{{ i.pill.contentTitle }}</div>
            <div class="text-left">
              <label class="bg-azuloscuro rounded-sm text-white text-xs px-2 py-1">
                ¡Estás a tiempo!
              </label>
            </div>
            <div class="flex  bottom-0 pb-4 absolute text-white font-medium" style="font-size: .6rem">
                <div class="flex items-center">
                  <img src="@/assets/images/tiempo_de_lectura.svg" class="inline-block w-3 h-3 mr-1"/>
                  <span style="padding-top:2px;">{{i.pill.estimatedTime}} {{localizeUnit(i.pill.estimatedTimeUnit)}}</span>
                </div>

                <div class="flex items-center">
                  <img src="@/assets/images/fecha_de_publicacion.svg" class="inline-block w-3 h3 ml-2 mr-1" />
                  <span style="padding-top:2px;">{{i.startDate | date}}</span>
                </div>

                <div class="flex items-center">
                  <div class="inline-block w-3 h-3 ml-2 mr-1 rounded-circle bg-yellow" style="vertical-align: sub"/>
                  <span>Pendiente</span>
                </div>
            </div>
          </div>
          <div
            v-if="idx != 0"
            class="float-left bg-azulceleste rounded-lg px-6 py-12 border border-gray-300 shadow text-center mr-5"
            style="width: 250px; min-height: 210px"
          >
            <img src="@/assets/images/lock.svg" class="inline-block mb-3 w-10 h-10" />
            <div
              class="text-azuloscuro text-sm font-medium"
            >Completa las pills anteriores para poder desbloquear esta.</div>
          </div>
        </div>

        <div>
          <div
            class="float-left bg-white rounded-lg px-6 py-12 border border-gray-300 shadow text-center mr-5"
            style="width: 250px; min-height: 210px"
          >
            <img src="@/assets/images/cooming_soon.svg" class="inline-block mb-3 w-10 h-10" />
            <div class="text-azuloscuro text-sm font-medium">
              Pronto tendrás una nueva Pill
              <br />disponible.
            </div>
          </div>
        </div>
      </div>
    </div>

    <h1 class="text-azuloscuro text-xl font-semibold p-4">Pills resueltas</h1>
    <div
      v-for="(i, idx) in completedPills"
      v-bind:key="idx"
      class="mb-4 px-4 cursor-pointer"
      @click="abrirPill(i.pill.contentType, i, idx)"
    >
      <Pill :pill="i" :isInWishlist="isInWishlist(i.pill)"/>
    </div>

    <div
      v-if="completedPills.length && pagination.current < pagination.last"
      class="flex justify-center"
    >
      <a
        @click.prevent="morePills"
        class="flex justify-center bg-azuloscuro rounded-full cursor-pointer text-white cursor-pointer px-8 py-3"
      >Cargar mas pills</a>
    </div>

    <Menu current="home"/>
  </div>
</template>

<script>
import Vue from "vue";
import Utilities from "@/plugins/Utilities.js";
import PillsLists from "@/plugins/PillsLists.js";
import pills from "@/plugins/api/pills/pills";
import auth from "@/plugins/api/users/auth";
import users from "@/plugins/api/users/users";
import Zondicon from "vue-zondicons";
import Menu from "@/components/Menu";
import Pill from "@/components/Pill";
import wishlist from "../plugins/api/wishlist/wishlist";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import setTitle from "../plugins/title";

const Home = {
  name: "Home",
  layout: "layout",
  components: {
    Menu,
    Zondicon,
    Pill,
    Loading
  },
  data: function() {
    return {
      completedPills: [],
      pendingPills: [],
      pagination: {
        current: 1,
        last: 1
      },
      wishlist: [],
      loading: false,
      user: null,
      dismissedFinishedDialog: false
    };
  },
  beforeMount: function() {
    if (!Utilities.isLogged()) {
      this.$router.push({ name: "login" });
      return;
    }

    this.loadUser();
    this.loadPills();
    this.loadWishList();
  },
  methods: {
    dismissFinishedDialog () {
      this.dismissedFinishedDialog = true
    },
    async loadUser() {
      this.loading = true
      try {
        const response = await users.getSelfUser();
        this.user = response.data;
      } catch (e) {
        console.error(e);
      }
      this.loading = false
    },
    abrirPill: function(tipo, i, idx) {
      localStorage.setItem('last_pill', JSON.stringify({ i, idx }))
      if (tipo == "0") {
        this.$router.push({ name: "pills_video", params: { i, idx } });
      }

      if (tipo == "1") {
        this.$router.push({ name: "pills_pdf", params: { i, idx } });
      }

      if (tipo == "2") {
        this.$router.push({ name: "pills_audio", params: { i, idx } });
      }

      if (tipo == "3") {
        this.$router.push({ name: "pills_text", params: { i, idx } });
      }

      if (tipo == "4") {
        this.$router.push({ name: "pills_image", params: { i, idx } });
      }
    },
    async loadWishList() {
      wishlist.getWishList().then(response => {
        this.wishlist = response.data["hydra:member"]
      })
    },
    isInWishlist(pill) {
      return this.wishlistIds.includes(pill['@id'])
    },
    async loadPills() {
      this.loading = true
      await pills
        .getPendingPills()
        .then(response => {
          this.pendingPills = response.data["hydra:member"];
        })
        .catch(e => {
          console.log(e);
        });
      await pills
        .getCompletedPills().then(response => {
            this.completedPills = response.data["hydra:member"];
        })
        .catch(e => {
            console.log(e);
        });
      this.loading = false
    },
    localizeUnit(unit) {
      if (!unit) {
        return ''
      }

      if (unit === 'hours') {
        return 'hrs'
      }

      if (unit === 'minutes') {
        return 'min'
      }

      if (unit === 'seconds') {
        return 'seg'
      }

      return unit
    }
  },
  filters: {
    date: function(value) {
      return new Date(value).toLocaleDateString("es-ES");
    }
  },
  computed: {
    wishlistIds: function () {
      return this.wishlist.map(w => w.pill)
    },
    shouldShowFinishedDialog () {
      if (this.dismissedFinishedDialog) {
        return false
      }

      if (!this.user) {
        return false
      }

      if (!this.user.endDate) {
        return false
      }

      const endDate = (new Date(this.user.endDate)).setHours(0,0,0,0);
      if ((new Date()).setHours(0,0,0,0) > endDate) {
        return true
      }

      return false
    }
  },
  created () {
    setTitle('Inicio')
  }
};

export default Home;
</script>
